<template>
    <div>
        <Archive
            ref="archiveBill"
            @modelChanged="$emit('modelChanged', $event)"
        />

        <CancelCharging
            ref="cancelCharging"
            @modelChanged="$emit('modelChanged', $event)"
        />

        <Negotiate
            ref="negotiate"
            @modelChanged="$emit('modelChanged', $event)"
        />

        <Recalculate
            ref="recalculate"
            @modelChanged="$emit('modelChanged', $event)"
        />
        <Transmit
            ref="transmit"
            @modelChanged="$emit('modelChanged', $event)"
        />

        <Unarchive
            ref="unarchiveBill"
            @modelChanged="$emit('modelChanged', $event)"
        />
    </div>
</template>

<script>
import Archive from './Archive'
import CancelCharging from './CancelCharging'
import Negotiate from './Negotiate'
import Recalculate from './Recalculate'
import Transmit from './Transmit'
import Unarchive from './Unarchive'

export default {
    components: {
        Archive,
        CancelCharging,
        Negotiate,
        Recalculate,
        Transmit,
        Unarchive,
    },

    methods: {
        async accessPaymentPage(model) {
            window.open(model.url, '_blank').focus()
        },

        async accessNFPage(model) {
            window.open(model.invoice_url, '_blank').focus()
        },

        async archive(model) {
            await this.$refs.archiveBill.open(model)
        },

        async cancelCharging(model) {
            await this.$refs.cancelCharging.open(model)
        },

        async sync(model) {
            let res = await model.sync()
            if (!res) return

            this.$emit('modelChanged')
            this.$bus.$emit(
                'notify',
                'success',
                this.$t('actions.bill.sync.success'),
            )
        },

        async recalculate(model) {
            await this.$refs.recalculate.open(model)
        },

        async transmit(model) {
            await this.$refs.transmit.open(model)
        },

        async unarchive(model) {
            await this.$refs.unarchiveBill.open(model)
        },

        async negotiate(model) {
            await this.$refs.negotiate.open(model)
        },
    },
}
</script>

<style></style>
